import React from 'react';

export const homepage = {
  bannerData2: {
    heroContent: {
      title: 'Innovative Molecular Diagnostic Testing',
      description:
        'Determine your genetic predisposition to some of the leading illnesses in America. Atlantic Labs provides easy to use kits that provide fast, accurate and actionable results to help enhance your future health.',
    },
    generalBtn: {
      type: 'internal_link',
      text: 'Learn More',
      link: '/#accurate-testing',
      extraClass: 'btn-default',
    },
    slickSlider: [
      {
        image: '/images/pages/home-smiley-sir.webp',
        title: null,
        subtitle: null,
        description: null,
        href: '#',
      },
      {
        image: '/images/pages/home-banner-baby.png',
        title: null,
        subtitle: null,
        description: null,
        href: '#',
      },
      {
        image: '/images/pages/home-banner-microscope.jpeg',
        title: null,
        subtitle: null,
        description: null,
        href: '#',
      },
    ],
    abideLogos: {
      title: 'Proud to Work with & Adhere to:',
      logos: [
        [
          {
            img: '/images/partners/CLIA.png',
            alt: 'CLIA-logo',
          },
          {
            img: '/images/partners/OSHA.png',
            alt: 'OSHA-logo',
          },
          {
            img: '/images/partners/ILLUMINA.png',
            alt: 'ILLUMINA-logo',
          },
          {
            img: '/images/partners/CMS.png',
            alt: 'CMS-logo',
          },
          {
            img: '/images/partners/HIPAA.png',
            alt: 'HIPAA-logo',
          },
          {
            img: '/images/partners/MEDICAID.png',
            alt: 'MEDICAID-logo',
          },
        ],
      ],
    },
  },

  expertsCTO: {
    twoImagesDecor: {
      image1: { src: '/images/decor/decor-sticks.svg', alt: 'decor sticks' },
      image2: { src: '/images/decor/decor-small-waves.svg', alt: 'waves image' },
    },
    sectionTitle: {
      bigTitle: 'Experts in genetics, so you don’t have to be.',
      description:
        'We provide our clients access to safe, simply genetic tests that can be conducted in the privacy of their own homes, to help them avoid unexpected, future medical complications and improve the quality of their lives.',
    },
    twoImagesDecor2: {
      image1: { src: '/images/decor/decor-genes-drops.svg', alt: 'genes drops' },
      image2: { src: '/images/decor/decor-waves.svg', alt: 'waves image' },
    },
  },

  accurateTesting: {
    divider: {
      lines: 1,
      text: 'OUR HEALTH TESTS',
    },
    sectionTitle: {
      smallTitle: 'Accurate Testing For Optimal Health',
      subtitle: null,
      description: (
        <>
          Non-invasive test kits that you can administer from home in less than 2 minutes. <br /> Let us handle the rest.
        </>
      ),
    },
    cards: [
      {
        type: 'internal_link',
        linkTo: '/genomics/cancer',
        cardImg: '/images/pages/home-card-cancer.png',
        cardMainTitle: 'Cancer',
        cardMainDescription: 'Our cancer screening test analyzes a leading 113 genes to determine whether you’re predisposed to an increased risk for most common, hereditary cancers.',
        thumbImg: '/images/nav_footer/Atlantic_labs_long.svg',
        title: 'Learn More Here',
        titleFlipper: 'Click to Learn More',
        desc: 'Click To Learn More',
      },
      {
        type: 'internal_link',
        linkTo: '/genomics/pharmacogenomics',
        cardImg: '/images/pages/home-card-pharmacogenomics.png',
        cardMainTitle: 'Medication',
        cardMainDescription: 'This important test is designed to help you understand how your body will react to certain types of medications.',
        thumbImg: '/images/nav_footer/Atlantic_labs_long.svg',
        title: 'Learn More Here',
        titleFlipper: 'Click to Learn More',
        desc: 'Click To Learn More',
      },
    ],
  },

  howTestingWorks: {
    soloImage: { src: '/images/pages/home-lab-girl-reading.png', alt: 'reading test' },
    sectionTitle: {
      bigTitle: 'How Testing Works',
      subtitle: '4 simple steps to fast, accurate results.',
      description: 'You stay informed every step along the way.',
    },
    accordionBS: {
      openFirst: true,
      items: [
        {
          title: 'Initial Consultation',
          text: 'Conveniently schedule an appointment online. We offer same day appointments, including evening and weekends. Our consultant will collect details about your personal history and risk factors, to determine if genetic testing is right for you, and determine if your medical insurance will cover the cost of testing.',
        },
        {
          title: 'Physician Review',
          text: 'All Atlantic Labs Tests are ordered by either your own physician or one of the physicians in our Telemedicine network, who can determine your eligibility and order testing on your behalf. There is no charge for this service.',
        },
        {
          title: 'Ship You Test Kit',
          text: 'Change to say: Once we receive consent from your treating physician we will ship your test kit to your home along with simple, detailed instructions on how to conduct the test and mail it back to our laboratory free of charge.',
        },
        {
          title: 'Genetic Counselling',
          text: 'After processing your sample at our laboratory, we will return the results to you and your treating physician, and one of our genetic counselors will call you to discuss your results and any findings that resulted from your test. You will receive a digital and hardcopy version of your results, which will include actionable insights that you and your physician can integrate into your personal medical care plan.',
        },
      ],
    },
  },

  callToAction: {
    sectionTitle: {
      bigTitle: 'Let Us Help Put Your Mind At Ease',
    },
    generalBtn: {
      type: 'internal_link',
      text: 'Order Your Test Here',
      link: '/order-test',
    },
  },

  illuminaVideos: {
    titleSection: {
      bigTitle: 'Learn More about Our Cutting Edge Technology',
      smallTitle: null,
      subtitle: null,
      description:
        'Illumina is a leading developer, manufacturer, and marketer of life science tools and integrated systems for large-scale analysis of genetic variation and function. These systems are enabling studies that were not even imaginable just a few years ago, and moving us closer to the realization of personalized medicine.',
    },
    cards: [
      {
        type: 'external_link',
        linkTo: 'https://www.youtube.com/watch?v=dBzzXEIVM-A&t=73s',
        cardImg: '/images/pages/home-illumina1.png',
        thumbImg: '/images/partners/ILLUMINA.svg',
        title: 'Healthcare Experts View on Comprehensive Genomic Profiling',
        desc: 'A global genomics leader, Illumina provides comprehensive next-generation sequencing solutions to the research, clinical, and applied markets.',
      },
      {
        type: 'external_link',
        linkTo: 'https://www.youtube.com/watch?v=aG7jTzGeLu4&ab_channel=Illumina',
        cardImg: '/images/pages/home-illumina2.png',
        thumbImg: '/images/partners/ILLUMINA.svg',
        title: 'Discover Demonstrated NGS Oncology Workflows',
        desc: 'Next-generation sequencing (NGS) empowers researchers to assess multiple genes in a single test.',
      },
      {
        type: 'external_link',
        linkTo: 'https://www.youtube.com/watch?v=xaguct7saTw&list=PLKRu7cmBQlaiQbVkCco7Kre3KkyElP04h&index=7',
        cardImg: '/images/pages/home-illumina3.png',
        thumbImg: '/images/partners/ILLUMINA.svg',
        title: 'Role of Genomics in Identifying Biomarkers for Response and Resistance to Anti-Cancer Immunotherapy',
        desc: 'Dr Eliezer Van Allen, Assistant Professor at Harvard Medical School and Medical Oncologist at the Dana Farber Cancer Institute, discusses his groundbreaking work in the genomics of cancer immunotherapy. ',
      },
    ],
  },
};
